module.exports = __webpack_public_path__ + "assets/654f8d8087218e84d2ab000998759b09.png";